import ChatWidget from "./ChatWidget";
import Footer from "./Footer";
import Header from "./Header";
import "./Trading.css";
import trade from "../assets/trading.png"
import {
  CheckCircle,
  IndianRupee,
  LineChart,
  UserCheck,
  ArrowUpDown
} from "lucide-react";


const Trading = () => {
  return (
   <>
   <div>
    <Header/>
   </div>
   <section className="trading-hero">
      <div className="trading-hero-content">
        <h1>Trading</h1>
        <p>
          Tredixo.live offers a comprehensive platform for all your trading
          needs. From equities to commodities, explore the diverse range of
          financial instruments.
        </p>
      </div>

      <div className="trading-content">
        <div className="trading-image">
          {/* <img
            src="/assets/trading.png"
            alt="Trading App"
          /> */}
          <img src={trade} alt="Trading App" />
        </div>

        <div className="trading-info">
          <h2>
            How <span>Tredixo.live</span> Offers Value
          </h2>

          <ul className="trading-list">
  <li>
    <CheckCircle className="trading-icon" />
    Low  Brokerage Fees
  </li>

  <li>
    <IndianRupee className="trading-icon" />
    No Annual Maintenance Charges (AMC)
  </li>

  <li>
    <LineChart className="trading-icon" />
    Enjoy up to 500x Leverage
  </li>

  <li>
    <UserCheck className="trading-icon" />
    Instant Account Settlement
  </li>

  <li>
    <ArrowUpDown className="trading-icon" />
    24/7 Deposit and Withdrawal Support
  </li>
</ul>

        </div>
      </div>
    </section>
     <div>
    <Footer />
      <ChatWidget />
   </div>
   </>
    
  );
};

export default Trading;
